import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function ForYouSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-105">
      <div className="max-w-6xl mx-auto" data-id="element-106">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16" data-id="element-107">
          {/* For You Column */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-green-50/50 p-8 rounded-2xl border border-green-100" data-id="element-108">
            <h3 className="text-2xl font-bold text-brown mb-6 flex items-center gap-3" data-id="element-109">
              <span className="bg-green-100 p-2 rounded-full text-green-700" data-id="element-110">
                <Check className="w-5 h-5" data-id="element-111" />
              </span>
              Esto es para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-112">
              <li className="flex items-start gap-3" data-id="element-113">
                <Check className="w-5 h-5 text-green-600 mt-1 flex-shrink-0" data-id="element-114" />
                <span className="text-brown-light" data-id="element-115">
                  Eres una madre primeriza con un bebé de 0 a 24 meses.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-116">
                <Check className="w-5 h-5 text-green-600 mt-1 flex-shrink-0" data-id="element-117" />
                <span className="text-brown-light" data-id="element-118">
                  Sientes que las discusiones con tu pareja por la crianza se
                  están volviendo un patrón.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-119">
                <Check className="w-5 h-5 text-green-600 mt-1 flex-shrink-0" data-id="element-120" />
                <span className="text-brown-light" data-id="element-121">
                  Quieres soluciones prácticas, sin sesiones largas ni lecturas
                  eternas.
                </span>
              </li>
            </ul>
          </motion.div>

          {/* Not For You Column */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-gray-50 p-8 rounded-2xl border border-gray-100" data-id="element-122">
            <h3 className="text-2xl font-bold text-brown mb-6 flex items-center gap-3" data-id="element-123">
              <span className="bg-gray-200 p-2 rounded-full text-gray-600" data-id="element-124">
                <X className="w-5 h-5" data-id="element-125" />
              </span>
              Esto NO es para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-126">
              <li className="flex items-start gap-3" data-id="element-127">
                <X className="w-5 h-5 text-gray-400 mt-1 flex-shrink-0" data-id="element-128" />
                <span className="text-brown-light" data-id="element-129">
                  Buscas terapia de pareja profunda y estructural.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-130">
                <X className="w-5 h-5 text-gray-400 mt-1 flex-shrink-0" data-id="element-131" />
                <span className="text-brown-light" data-id="element-132">
                  No estás dispuesta a probar micro-reuniones diarias de 10
                  minutos.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-133">
                <X className="w-5 h-5 text-gray-400 mt-1 flex-shrink-0" data-id="element-134" />
                <span className="text-brown-light" data-id="element-135">
                  Esperas que los problemas se resuelvan solos sin ningún
                  esfuerzo.
                </span>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}